const validPercent = value => typeof value === 'number' && Number.isFinite(value) && value >= 0;

// Prefer the explicit limits list; older responses only provide the period fields.
export const getClaudeUsageLimits = usage => {
  const limits = Array.isArray(usage?.limits) ? usage.limits : [];
  const result = [];
  const addPeriod = (kind, fallback) => {
    const limit = limits.find(item => item?.kind === kind && validPercent(item.percent));
    const source = limit || fallback;
    const percent = limit ? limit.percent : fallback?.utilization;
    if (!validPercent(percent)) return;
    result.push({ kind, percent, severity: source.severity, resetsAt: source.resets_at });
  };
  addPeriod('session', usage?.five_hour);
  addPeriod('weekly_all', usage?.seven_day);
  return result;
};
